import { translateText } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import BestFacilities from '../../components/shared/BestFacilities';
import { useSelector, useDispatch } from 'react-redux';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { showErrorMsg, showInfoMsg, showSuccessMsg, validateAnyFormField } from '../../../helpers/ValidationHelper';
import { readOrderConfirmationApi as MakeApiCallAsync, loadOrderQrPayment } from '../../../helpers/OrderConfirmationApi';
import Config from '../../../helpers/Config';
import rootAction from '../../../stateManagment/actions/rootAction';
import OrderSummary from '../../components/cart/OrderSummary';
import { makePriceRoundToTwoPlaces, makeProductShortDescription } from '../../../helpers/ConversionHelper';
import { Helmet } from 'react-helmet';
import { Media,Input, Label, Form, Row, Col, FormGroup, Modal, ModalBody, Button } from "reactstrap";


//--strip

import { GetDefaultCurrencyCode, GetDefaultCurrencySymbol, getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';

//--Paypal
import GlobalEnums from '../../../helpers/GlobalEnums';

import tickimage from '../../../resources/custom/images/tickimage.png';
import order_status from '../../../resources/custom/images/order_status.gif';
import OrderQrPayment from '../../components/cart/OrderQrPayment';
import { getConfiguredQrPayment } from '../../../helpers/OrderQrPaymentHelper';




const Orderconfirm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [qrPaymentOrder, setQrPaymentOrder] = useState(null);



    const [showCardSectionStripe, setshowCardSectionStripe] = useState(false);
    const [showCardSectionPaypal, setshowCardSectionPaypal] = useState(false);
    const [PaymentMethod, setPaymentMethod] = useState(process.env.REACT_APP_STRIPE_PAYMENT_METHOD ?? 5);
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
    const [OrderNote, setOrderNote] = useState('');
    const [CartSubTotal, setCartSubTotal] = useState(0);
    const [ShippingSubTotal, setShippingSubTotal] = useState(0);
    const [OrderTotal, setOrderTotal] = useState(0);
    const [OrderTotalAfterDiscount, setOrderTotalAfterDiscount] = useState(0);
    const [cartProductsData, setCartProductsData] = useState(0);
    const [CouponCode, setCouponCode] = useState('');
    const [IsCouponCodeApplied, setIsCouponCodeApplied] = useState(false);
    const [IsAlreadyDiscountApplied, setIsAlreadyDiscountApplied] = useState(false);
    const [CouponCodeCssClass, setCouponCodeCssClass] = useState('cart-coupon-code');
    const [paypalOrderID, setPaypalOrderID] = useState(false);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [ConfirmedOrderNumber, setConfirmedOrderNumber] = useState('');



    const loginUserDataJson = useSelector(state => state.userReducer.user);
    const loginUser = JSON.parse(loginUserDataJson ?? "{}");

    const cartJsonDataSession = useSelector(state => state.cartReducer.cartItems);
    const cartItemsSession = JSON.parse(cartJsonDataSession ?? "[]");


    if (loginUser == undefined || loginUser.UserID == undefined || loginUser.UserID < 1) {
        navigate('/' + getLanguageCodeFromSession() + '/login');
    }

    const GetCouponCodeInfo = async () => {

        if (IsCouponCodeApplied) {
            showInfoMsg('Coupon code is already applied!');
            return false;
        }


        let isValid = validateAnyFormField('Coupon Code', CouponCode, 'text', null, 30, true);
        if (isValid == false) {
            return false;
        }



        const headersCoupon = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }

        const paramCoupon = {
            requestParameters: {
                CouponCode: CouponCode,
                cartJsonData: JSON.stringify(cartItemsSession),
            },
        };


        const couponResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_COUPON_CODE_DISCOUNT'], Config['COMMON_CONTROLLER_SUB_URL'], paramCoupon, headersCoupon, "POST", true);


        if (couponResponse != null && couponResponse.data != null) {

            let copounData = JSON.parse(couponResponse.data.data);
            console.log(copounData);
            if (copounData != undefined && copounData.DiscountValueAfterCouponAppliedWithQuantity != undefined && copounData.DiscountValueAfterCouponAppliedWithQuantity > 0) {
                setOrderTotalAfterDiscount((OrderTotal - copounData.DiscountValueAfterCouponAppliedWithQuantity ?? 0));
                setIsCouponCodeApplied(true);
            } else {
                showErrorMsg('Invalid coupon code!');
            }

        }



    }

    const handleCheckoutOnSubmit = async (e) => {
        

        try {
            e.preventDefault();

            //-- First Disable all forms
            setshowCardSectionStripe(false);
            setshowCardSectionPaypal(false);

            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                setshowCardSectionStripe(true);
            } else if (PaymentMethod === process.env.REACT_APP_PAYPAL_PAYMENT_METHOD) {
                setshowCardSectionPaypal(true);
            }
            else if (PaymentMethod === process.env.REACT_APP_CASH_ON_DELIVERY_PAYMENT_METHOD) {

                //--start loader
                dispatch(rootAction.commonAction.setLoading(true));


                PlaceAndConfirmCustomerOrder(null);

                //--stop loader
                setTimeout(() => {
                    dispatch(rootAction.commonAction.setLoading(false));
                }, LOADER_DURATION);

            }
        } catch (err) {
            showErrorMsg("An error occured. Please try again!");
            console.log(err.message);
            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                HandleStripCardModal();
                HandlePaypalCardModal();
            }

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);
        }



    }


    const PlaceAndConfirmCustomerOrder = async (StripPaymentToken, payPalOrderConfirmJson = "{}") => {

        try {

            const headersStrip = {
                Accept: 'application/json',
'Content-Type': 'application/json'

            }


            const paramSrip = {
                requestParameters: {
                    UserID: loginUser.UserID,
                    OrderNote: OrderNote,
                    cartJsonData: JSON.stringify(cartItemsSession),
                    CouponCode: IsCouponCodeApplied == true ? CouponCode : "",
                    PaymentMethod: PaymentMethod,
                    paymentToken: StripPaymentToken ?? "",
                    payPalOrderConfirmJson: payPalOrderConfirmJson ?? "",
                    recordValueJson: "[]",
                },
            };



            const stripServerResponse = await MakeApiCallAsync(Config.END_POINT_NAMES['POST_CUSTOMER_ORDER'], Config['COMMON_CONTROLLER_SUB_URL'], paramSrip, headersStrip, "POST", true);
            if (stripServerResponse != null && stripServerResponse.data != null && stripServerResponse.status == 200) {
                let stripServerResponseDetail = JSON.parse(stripServerResponse.data.data != undefined && stripServerResponse.data.data != "" ? stripServerResponse.data.data : "[]");

                if (stripServerResponseDetail.length > 0 && stripServerResponseDetail[0].ResponseMsg != undefined && stripServerResponseDetail[0].ResponseMsg == "Order Placed Successfully") {
                    showSuccessMsg("Order Placed Successfully!");




                    setTimeout(function () {
                        navigate('/' + getLanguageCodeFromSession() + '/');

                        //--clear customer cart
                        dispatch(rootAction.cartAction.setCustomerCart('[]'));
                        dispatch(rootAction.cartAction.SetTotalCartItems(0));
                        localStorage.setItem("cartItems", "[]");

                    }, 1000);


                } else {
                    showErrorMsg("An error occured. Please try again!");

                }

            } else {
                showErrorMsg("An error occured. Please try again!");

            }


            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                HandleStripCardModal();
            } else if (PaymentMethod === process.env.REACT_APP_PAYPAL_PAYMENT_METHOD) {
                HandlePaypalCardModal();
            }





        } catch (err) {
            showErrorMsg("An error occured. Please try again!");
            console.log(err.message);
            if (PaymentMethod === process.env.REACT_APP_STRIPE_PAYMENT_METHOD) {
                HandleStripCardModal();
            }

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);

        }


    }


    const HandleStripCardModal = () => {
        setshowCardSectionStripe(!showCardSectionStripe);
    }

    const HandlePaypalCardModal = () => {
        setshowCardSectionPaypal(!showCardSectionPaypal);
    }

    // creates a paypal order
    const createOrder = (data, actions) => {
        return actions.order
            .create({
                purchase_units: [
                    {
                        description: "Sunflower",
                        amount: {
                            //currency_code: "USD",
                            currency_code: GetDefaultCurrencyCode(),
                            value: OrderTotalAfterDiscount != undefined && OrderTotalAfterDiscount > 0 ? OrderTotalAfterDiscount : OrderTotal,
                        },
                    },
                ],
                // not needed if a shipping address is actually needed
                application_context: {
                    shipping_preference: "NO_SHIPPING",
                },
            })
            .then((paypalOrderID) => {
                setPaypalOrderID(paypalOrderID);
                return paypalOrderID;
            });
    };

    // check paypal Approval
    const onApprove = (data, actions) => {

        return actions.order.capture().then(function (details) {
            const { payer } = details;
            //setSuccess(true); replace with your own

            //-- Set paypal json response if approve
            let JsonDetail = JSON.stringify(details);

            //--start loader
            dispatch(rootAction.commonAction.setLoading(true));

            setTimeout(() => {
                PlaceAndConfirmCustomerOrder(null, JsonDetail);
            }, 500);

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);


            HandlePaypalCardModal();
        });
    };

    //capture likely error for paypal
    const onError = (data, actions) => {
        HandlePaypalCardModal();
        showErrorMsg("An error occured. Please try again!");
    };


    useEffect(() => {

        window.scrollTo(0, 0)
        // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            const headers = {
                Accept: 'application/json',
'Content-Type': 'application/json'
            }

            //--Get cart data
            const paramCart = {
                requestParameters: {
                    cartJsonData: JSON.stringify(cartItemsSession),
                    recordValueJson: "[]",
                },
            };


            const customerCartResponse = await MakeApiCallAsync(Config.END_POINT_NAMES["GET_CUSTOMER_CART_ITEMS"], Config['COMMON_CONTROLLER_SUB_URL'], paramCart, headers, "POST", true);
            if (customerCartResponse != null && customerCartResponse.data != null) {

                let finalData = JSON.parse(customerCartResponse.data.data);
                console.log(finalData);

                if (finalData != null) {
                    setTimeout(() => {

                        setCartProductsData(finalData.productsData);
                        setCartSubTotal(finalData.cartSubTotal);
                        setShippingSubTotal(finalData.shippingSubTotal);
                        setOrderTotal(finalData.orderTotal);

                        if (finalData.productsData.length > 0 && finalData.productsData.some(el => el.DiscountedPrice > 0)) {
                            setIsAlreadyDiscountApplied(true);
                        }

                    }, 500);
                }




            }

        }


        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));


        // call the function
        dataOperationInUseEffect().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);

    }, [])


    useEffect(() => {
        // declare the data fetching function
        const dataOperationFunc = async () => {

            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            };

            const context = location.state?.qrPaymentContext;
            const requestedOrder = context && String(context.userId) === String(loginUser.UserID) ? context.orderNumber : null;
            const response = await loadOrderQrPayment(requestedOrder);
            const data = response.data;
            const savedOrderNumber = data?.orderNumber ?? data?.OrderNumber;
            if (response.status === 200 && typeof savedOrderNumber === 'string' && savedOrderNumber.trim()
                && savedOrderNumber === response.requestedOrderNumber) {
                setConfirmedOrderNumber(savedOrderNumber);
                setQrPaymentOrder(getConfiguredQrPayment(response, savedOrderNumber));
            } else {
                setConfirmedOrderNumber('');
                setQrPaymentOrder(null);
                console.warn('[Order confirmation] Admin API request failed with HTTP status:', response.status);
                showErrorMsg(response.status === 401 || response.status === 403
                    ? 'Please sign in again to load your order payment QR.'
                    : 'Order confirmation could not be loaded. Please refresh or contact us on WhatsApp.');
            }

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["Checkout"], null, MakeApiCallAsync);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }
        }
        // call the function
        dataOperationFunc().catch(console.error);
    }, [])

    return (
        <>


            <Helmet>
                <title>{siteTitle}{translateText(" - Confirmed")}</title>
                <meta name="description" content={siteTitle + " - Order Confirmed"} />
                <meta name="keywords" content="Order Confirmed"></meta>
            </Helmet>
            <SiteBreadcrumb title={translateText("Order Confirmed")} parent="Home" />


            <section className="bg-white">
                <div className="custom-container">
                    <div className="checkout-page contact-page">
                        <div className="checkout-form">
                            <Form onSubmit={(event) => event.preventDefault()}>
                                <Row>
                                    <Col lg="12" sm="12" xs="12">
                                        {/* <div className="checkout-title">
                                            <h3>
                                                {LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Billing Details", "lbl_check_billdetail")
                                                    :
                                                    "Your Order has been place Successfully!"
                                                }
                                            </h3>
                                        </div> */}
                                        <div className="theme-form">
                                            <Row className="check-out ">
                                                
                                           
      
                                                <div className="text-center ukl-order-confirmation">
                                                    {ConfirmedOrderNumber &&
                                                        <div className="ukl-confirmed-order-number" aria-label={translateText(`Order number ${ConfirmedOrderNumber}`)}>
                                                            <span>{translateText("Order Number")}</span>
                                                            <strong>#{ConfirmedOrderNumber}</strong>
                                                        </div>
                                                    }
                                                    
                                                    {!qrPaymentOrder && (
                                                    <>
                                                    {/* Green Circle with Check */}
                                                    <div className="justify-center items-center">
                                                                <center>  <Media src={tickimage} className="w-6 h-6" /></center>   
                                                    </div>

                                                    {/* Title */}
                                                    <h1 className="text-3xl md:text-4xl font-semibold mt-6 text-gray-800">{translateText("Thank you for your purchase!.")}</h1>
                                                    </>
                                                    )}

                                                    {/* Subtitle */}
                                                    {qrPaymentOrder ? (
                                                        <>{qrPaymentOrder.rules.map(rule => <OrderQrPayment key={rule.id} ruleId={rule.id} ruleName={rule.name}
                                                            upiId={rule.upiId} payeeName={rule.payeeName}
                                                            orderNumber={qrPaymentOrder.orderNumber} amount={qrPaymentOrder.amount} />)}</>
                                                    ) : (
                                                    <>
                                                    <p className="text-gray-600 mt-3 text-lg">{translateText("Order received successfully. We'll send the bill amount and payment QR code via WhatsApp shortly.")}</p>

                                                    {/* Order ID */}
                                                    <p className="text-gray-500 mt-2">{translateText("Please wait. Due to a high volume of orders, we are currently processing your request.")}</p>
                                                    <p className="text-gray-500 mt-2">{translateText("Estimated processing time: 1 day.(confirm and share QR for Payments via WhatsApp)")}</p>
                                                    </>
                                                    )}
                                                    <div className="ukl-order-faq">
                                                        <span aria-hidden="true"><i className="fa fa-book" /></span>
                                                        <div>
                                                            <h2>{translateText("A quick read before your delivery")}</h2>
                                                            <p>{translateText("Please review our FAQs for payment instructions, delivery guidance, and how to store your products.")}</p>
                                                        </div>
                                                        <Link to={`/${getLanguageCodeFromSession()}/faq`}>{translateText("Read FAQs ")}<i className="fa fa-arrow-right" aria-hidden="true" /></Link>
                                                    </div>
                                                    {/* Optional Button */}
                                                    
                                                    <div className="justify-center items-center">
                                   
                                                    </div>
                                             
                                                </div>
                                                </Row>
                                                </div>
                                    </Col>
                                    {/* <Col lg="6" sm="12" xs="12">
                                        <div className="checkout-details theme-form  section-big-mt-space">

                                            {
                                                cartProductsData != undefined && cartProductsData != null && cartProductsData.length > 0
                                                    ?
                                                    <>
                                                        <div className="order-table table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" id="lbl_hdr_check_prdname">
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Product Name", "lbl_hdr_check_prdname")
                                                                                :
                                                                                "Product Name"
                                                                            }
                                                                        </th>
                                                                        <th scope="col" id="lbl_hdr_check_price">
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Price", "lbl_hdr_check_price")
                                                                                :
                                                                                "Price"
                                                                            }
                                                                        </th>
                                                                        <th scope="col" id="lbl_hdr_check_qty">
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Quantity", "lbl_hdr_check_qty")
                                                                                :
                                                                                "Quantity"
                                                                            }
                                                                        </th>
                                                                        <th scope="col" id="lbl_hdr_check_total">
                                                                            {LocalizationLabelsArray.length > 0 ?
                                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Total", "lbl_hdr_check_total")
                                                                                :
                                                                                "Total"
                                                                            }
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {cartProductsData?.map((data, idx) => (

                                                                        <tr key={idx}>
                                                                            <td className="product-name">
                                                                            {
                                                                                        makeProductShortDescription(data.ProductName, 50)
                                                                                    }
                                                                            </td>

                                                                            <td className="product-name">
                                                                                <span className="unit-amount">
                                                                                    {data.DiscountedPrice != undefined && data.DiscountedPrice > 0 ?
                                                                                        <>
                                                                                            <del style={{ color: "#9494b9" }}>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(data.Price)}</del> &nbsp; {GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(data.DiscountedPrice)}
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            {GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(data.Price)}
                                                                                        </>
                                                                                    }
                                                                                </span>
                                                                            </td>

                                                                            <td className="product-name">
                                                                                {data.Quantity}
                                                                            </td>

                                                                            {(() => {

                                                                                let itemSubTotal = (data.DiscountedPrice != undefined && data.DiscountedPrice > 0 ? data.DiscountedPrice : data.Price) * (data.Quantity ?? 1);

                                                                                return (

                                                                                    <td className="product-total">
                                                                                        <span className="subtotal-amount">{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(itemSubTotal)}</span>
                                                                                    </td>
                                                                                );

                                                                            })()}


                                                                        </tr>
                                                                    ))}

                                                                    <tr>
                                                                        <td className="order-subtotal" colSpan={3}>
                                                                            <span id="lbl_check_cartsubtotal" className="count">
                                                                                {LocalizationLabelsArray.length > 0 ?
                                                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Cart Subtotal", "lbl_check_cartsubtotal")
                                                                                    :
                                                                                    "Cart Subtotal"
                                                                                }
                                                                            </span>
                                                                        </td>


                                                                        <td className="order-subtotal-price">
                                                                            <span className="order-subtotal-amount">{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(CartSubTotal)}</span>
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className="order-shipping" colSpan={3}>
                                                                            <span id="lbl_check_shipping">
                                                                                {LocalizationLabelsArray.length > 0 ?
                                                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Shipping", "lbl_check_shipping")
                                                                                    :
                                                                                    "Packing & Shipping"
                                                                                }
                                                                            </span>
                                                                        </td>


                                                                        <td className="shipping-price">
                                                                            <span>{GetDefaultCurrencySymbol()}{makePriceRoundToTwoPlaces(ShippingSubTotal)}</span>
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className="total-price" colSpan={3}>
                                                                            <span id="lbl_check_ordtotal" className='order-total-check-lbl'>
                                                                                {LocalizationLabelsArray.length > 0 ?
                                                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Order Total", "lbl_check_ordtotal")
                                                                                    :
                                                                                    "Order Total"
                                                                                }
                                                                            </span>
                                                                        </td>



                                                                    </tr>


                                                                

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                    </>
                                            }

                                            
                                        </div>
                                    </Col> */}
                                </Row>
                            </Form>
                        </div>
                    </div>
                </div>
            </section>


           




        </>
    );
}

export default Orderconfirm;
